import React, { createContext, useState, useEffect, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getSessionToken, userMe } from 'src/api/api';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    const token = getSessionToken();
    if (!token) {
      setUser(null);
      return;
    }
    const resp = await userMe();
    if (resp.error) {
      if (resp.requireLogin) {
        setUser(null);
      }
      return;
    }
    setUser(resp);
  }

  useEffect(() => {
    fetchUser().then(() => {
      setLoading(false);
    });
  }, []);

  return (
    <AppContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AppContext.Provider>
  );
}

export const ProtectedRoute = ({ children }) => {
  const token = getSessionToken();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
};